import { render, staticRenderFns } from "./GExamCreateExamineeSettingStudents.vue?vue&type=template&id=70071344&"
import script from "./GExamCreateExamineeSettingStudents.vue?vue&type=script&lang=ts&"
export * from "./GExamCreateExamineeSettingStudents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports